export default "__VITE_ASSET__Dy46_Waq__"